<script>
  import { Heading } from 'flowbite-svelte';
  import Footer from '../components/Footer.svelte';
  import { CookieConsent } from '@button/ui';
  import { _ } from 'svelte-i18n';
  import { useLocation } from 'svelte-routing';
  const location = useLocation();

  const appStoreUrl = new URL(
    'https://posttap.bttn.io/?utm_source=loginbanner&btn_fallback_exp=appstore&btn_ref=0',
  );
  let utmSource;
  $: {
    utmSource = $location.state?.utm_source;
    if (utmSource) {
      appStoreUrl.searchParams.set('utm_source', utmSource);
    }
  }

  const columnClass =
    'lg:fixed lg:top-0 overflow-hidden h-1/2 lg:h-screen w-full lg:w-1/2'; // lg:max-h-[800px] lg:min-h-[800px]
  const bgImageClass =
    'bg-appBackground lg:bg-loginBackground-lg bg-no-repeat bg-bottom lg:bg-right-top';

  function handleSubmitLoginAmazon() {
    // eslint-disable-next-line no-undef
    gtag('event', 'login-amazon');
  }
</script>

<div class="h-screen">
  <div
    class={`bg-buttonBlue lg:left-0 lg:flex lg:flex-col lg:justify-center ${columnClass}`}
  >
    <div
      class="absolute flex items-center justify-start gap-x-3 pl-5 pt-8 lg:top-0 lg:pl-[40px] lg:pt-[46px]"
    >
      <img src="./images/posttap-logo-white.svg" alt="PostTap" />
      <img
        src="./images/created-by.svg"
        alt="Created by Button"
        class="hidden sm:block"
      />
    </div>
    <div
      class={`max-h-[406px] min-h-[406px] lg:flex lg:min-h-[800px] lg:flex-col lg:justify-center ${bgImageClass}`}
    >
      <div class="flex justify-center text-center">
        <Heading
          tag="h1"
          class="mt-[120px] max-w-[330px] font-bold leading-[48px] text-white lg:m-0 lg:max-w-lg lg:p-0 lg:leading-[56px] xl:leading-[56px]"
          customSize="text-3xl lg:text-4xl xl:text-5xl"
          >{$_('managedLogin.header', {
            default: 'Quickly and easily create shortlinks',
          })}</Heading
        >
      </div>
    </div>
  </div>
  <div class={`lg:right-0 ${columnClass}`}>
    <div
      class="flex h-full flex-col items-center justify-start gap-y-10 pt-16 text-center align-middle lg:justify-center lg:gap-y-8"
    >
      <div
        class="flex h-full flex-col items-center justify-start gap-y-10 text-center align-middle lg:justify-center lg:gap-y-8"
      >
        <Heading
          tag="h2"
          class="max-w-[330px] text-xl font-bold lg:text-xl xl:text-2xl"
          >{$_('managedLogin.subheader', {
            default: 'Continue by logging in with your Amazon Account',
          })}</Heading
        >
        <p class="max-w-md text-gray-600">
          {$_('managedLogin.mobileAnnouncmentBanner', {
            default: 'On a mobile device? PostTap is now available for iOS.',
          })}
          <a
            class="block text-buttonBlue/70 hover:underline"
            href={appStoreUrl.toString()}
          >
            {$_('managedLogin.mobileAnnouncmentBannerLink', {
              default: 'Tap here to download.',
            })}
          </a>
        </p>
        <form
          method="post"
          action="/auth/amazon"
          on:submit={handleSubmitLoginAmazon}
        >
          <button type="submit">
            <img
              alt="Login with Amazon"
              src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64"
              type="png"
              width="156"
              height="32"
            />
          </button>
          <label class="mt-4 block text-xs">
            <input type="checkbox" name="remember" /> Remember Me (uses cookies)
          </label>
        </form>
      </div>
      <div class="mb-5 text-xs md:text-sm" style="margin-top: auto">
        <Footer />
      </div>
    </div>
  </div>
  <CookieConsent divClass="w-full p-4" position="absolute" />
</div>
